import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePage } from "~/utils/content-fns";
import { BlockRenderer, type Block } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/partners/")({
  loader: async () => {
    const page = await loadStandalonePage({ data: { path: "partners/_index.md" } });
    return page as any;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: (loaderData as any).seo_title || (loaderData as any).title,
          description: (loaderData as any).seo_description,
          url: "/partners",
        })
      : [],
    links: seoLinks({ url: "/partners" }),
  }),
  component: () => {
    const p = Route.useLoaderData() as any;
    return <BlockRenderer blocks={(p.blocks || []) as Block[]} />;
  },
});
